<div
  class="inner"
  *ngIf="(facetList$ | async)?.facets as facets"
  [cxFocus]="isDialog ? dialogFocusConfig : {}"
  (esc)="close($event)"
  (click)="block($event)"
>
  <h4>
    {{ 'productList.filterBy.label' | cxTranslate }}
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
    </button>
  </h4>

  <!-- 
      Here we'd like to introduce configurable facet components, 
      either by using specific configuration or generic sproutlets 
      *ngIf="length != 1 &&  '{{ 'productList.filterBy.label' | cxTranslate }}' == ' Sub Categories '"
  -->
  <div >
    <vs-category-facet *ngIf="(catData$ | async)?.length > 0" [catFacet$]="catData$"></vs-category-facet>

    <cx-facet
    *ngFor="let facet of facets"
    #facetRef
    [facet]="facet"
    [cxFocus]="{ lock: true, trap: true, autofocus: 'a' }"
    (unlock)="expandFacetGroup(facet, facetRef)"
    [class.expanded]="isExpanded(facet) | async"
    [class.collapsed]="isCollapsed(facet) | async"
  ></cx-facet>
  </div>
  
</div>
